import { useTranslation } from "react-i18next";
import { useForm } from "@tanstack/react-form";
import { zodValidator } from "@tanstack/zod-form-adapter";
import { Alert, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { z } from "zod";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../hooks/useTypedSelector";
import { useEffect, useState } from "react";
import {
  attemptLogin,
  getAuthCSRF,
} from "../../infrastructure/slices/authSlice/authSlice";
import { toast } from "sonner";

export const LoginForm = () => {
  const { t } = useTranslation("common");
  const query = new URLSearchParams(window.location.search);
  const resetSuccess = query.get("resetSuccess");

  const [toasted, setToasted] = useState(false);

  const dispatch = useAppDispatch();

  const { csrfLoading, csrfLoaded, error } = useAppSelector(
    (state) => state.auth,
  );

  useEffect(() => {
    if (!csrfLoaded && !csrfLoading) {
      void dispatch(getAuthCSRF());
    }

    if (resetSuccess && !toasted) {
      toast.success(t("user.password.reset.success"));
      setToasted(true);
    }
  }, []);

  const form = useForm({
    defaultValues: {
      userString: "",
      password: "",
    },
    onSubmit: (values) => {
      void dispatch(attemptLogin(values.value));
    },
    validatorAdapter: zodValidator(),
  });

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          void form.handleSubmit();
        }}
      >
        <h3 className="text-center mb-4">{t("Login")}</h3>

        {error && <Alert variant={"danger"}> {t(error)} </Alert>}

        <form.Field
          name="userString"
          validators={{
            onSubmit: z.string(),
          }}
        >
          {(field) => {
            return (
              <Form.Group className="mb-3">
                <Form.Label>{t("Email")}</Form.Label>
                <Form.Control
                  id={field.name}
                  name={field.name}
                  value={field.state.value}
                  onBlur={field.handleBlur}
                  onChange={(e) => field.handleChange(e.target.value)}
                  isInvalid={field.state.meta.errors.length > 0}
                  required={true}
                />
                {field.state.meta.errors ? (
                  <Form.Control.Feedback type="invalid">
                    {field.state.meta.errors.join(", ")}
                  </Form.Control.Feedback>
                ) : null}
              </Form.Group>
            );
          }}
        </form.Field>
        <form.Field
          name="password"
          validators={{
            onSubmit: z.string().min(1, t("Password is required")),
          }}
        >
          {(field) => {
            return (
              <Form.Group>
                <Form.Label className="d-flex align-items-center">
                  {t("Password")}
                  <small className="ms-auto">
                    <Link to="/auth/forgot-password" tabIndex={1}>
                      {t("Forgot password")}
                    </Link>
                  </small>
                </Form.Label>
                <Form.Control
                  id={field.name}
                  name={field.name}
                  type="password"
                  value={field.state.value}
                  onBlur={field.handleBlur}
                  onChange={(e) => field.handleChange(e.target.value)}
                  isInvalid={field.state.meta.errors.length > 0}
                  required={true}
                />
                {field.state.meta.errors ? (
                  <Form.Control.Feedback type="invalid">
                    {field.state.meta.errors.join(", ")}
                  </Form.Control.Feedback>
                ) : null}
              </Form.Group>
            );
          }}
        </form.Field>
        <form.Subscribe>
          <Button type="submit" className="mt-3 w-100">
            {t("Login")}
          </Button>
        </form.Subscribe>
      </form>
    </>
  );
};
